import { Box } from '@mui/material';
import React from 'react';

interface PageAreaProps {
  children: React.ReactNode;
  fullHeight?: boolean;
}

const PageArea: React.FC<PageAreaProps> = ({ children, fullHeight = false }) => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 2,
        px: { xs: 2.5, md: 4 },
        py: { xs: 2.5, md: 3.5 },
        boxShadow: 0,
        border: 1,
        borderColor: 'divider',
        ...(fullHeight && {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }),
      }}
    >
      {children}
    </Box>
  );
};

export default PageArea;
